export default "__VITE_ASSET__b30f01ec__"